import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

/** Diálogo padrão para formulários de criação/edição. */
export default function FormDialog({
    open,
    onClose,
    onSubmit,
    title,
    description,
    submitLabel = 'Salvar',
    cancelLabel = 'Cancelar',
    loading = false,
    submitColor = 'primary',
    maxWidth = 'sm',
    fullScreen = false,
    disableBackdropClose = false,
    children,
}) {
    const handleClose = (event, reason) => {
        if (loading) return;
        if (disableBackdropClose && reason === 'backdropClick') return;
        onClose?.(event, reason);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!loading) onSubmit?.(event);
    };

    return (
        <Dialog open={Boolean(open)} onClose={handleClose} maxWidth={maxWidth} fullWidth fullScreen={fullScreen}>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: 'flex', flexDirection: 'column', height: fullScreen ? '100%' : 'auto' }}>
                <DialogTitle sx={{ pr: 6 }}>
                    {title}
                    <IconButton
                        aria-label="Fechar"
                        onClick={(e) => handleClose(e, 'closeButton')}
                        size="small"
                        sx={{ position: 'absolute', right: 12, top: 14, color: 'text.secondary' }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ flex: fullScreen ? 1 : 'initial' }}>
                    {description && <DialogContentText sx={{ mb: 2 }}>{description}</DialogContentText>}
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 0.5 }}>{children}</Box>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={(e) => handleClose(e, 'cancelButton')} disabled={loading}>
                        {cancelLabel}
                    </Button>
                    <Button type="submit" variant="contained" color={submitColor} loading={loading}>
                        {submitLabel}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}
